<template>
<!--我的订单-->
  <div class="orders">
    <!-- <div v-show="$route.meta.navShow"> -->
      <div class="titleWrap">
        <p class="titleName">学分认定</p>
      </div>
      <ul class="list">
      	<li class="clearfix">
          <img src="../../assets/zhengshu6.png" alt="" class="pull-left">
          <ul>
            <li class="title">全国物业行业项目经理职业资格证书</li>
            <li>证书编号：GD201306120118</li>
             <li>颁证机构：广东省物业管理协会</li>
              <li>证书有效期：2020/03/10 - 2021/03/10</li>
              <li><router-link to="/ziliao/xuefendetail">认定证明详情</router-link></li>
          </ul>
        </li>
        <li class="clearfix">
          <img src="../../assets/zhengshu6.png" alt="" class="pull-left">
          <ul>
            <li class="title">全国物业行业项目经理职业资格证书</li>
            <li>证书编号：GD201306120118</li>
             <li>颁证机构：广东省物业管理协会</li>
              <li>证书有效期：已失效</li>
              <li><router-link to="/ziliao/xuefendetail">认定证明详情</router-link></li>
          </ul>
        </li>
        <li class="clearfix">
          <img src="../../assets/zhengshu6.png" alt="" class="pull-left">
          <ul>
            <li class="title">全国物业行业项目经理职业资格证书</li>
            <li>证书编号：GD201306120118</li>
             <li>颁证机构：广东省物业管理协会</li>
              <li>证书有效期：已失效</li>
              <li><router-link to="/ziliao/xuefendetail">认定证明详情</router-link></li>
          </ul>
        </li>
      </ul>
      <div class="pageout"><Page :total="100" /></div>

  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #083C68;
    .titleName {
      float: left;
      line-height: 24px;
      border-bottom: 3px solid #083C68;
      padding-bottom: 13px;
    }
  }
  .pageout {
    text-align: center;
    margin-top: 25px;
    height: 34px;
  }
  .list{
    >li{
      padding: 20px;
      background-color: #F5F5F5;
      border:1px solid #dbdbdb;
      margin-bottom: 20px;
      font-size: 16px;
      color: #666;
      position: relative;
      ul{
        margin-left: 210px;
        li{
          line-height: 30px;
        }
      }
      .title{
        font-size: 20px;
        color: #000;
        margin-bottom: 20px;
      }
      span{
        color: #FF3333;
      }
      a{
        color: #fff ;
        font-size: 16px;
        background-color: #957960;
        position: absolute;
        bottom:20px;
        right: 20px;
        display: block;
        width: 120px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 5px;
      }
    }
  }



</style>
<script type="text/ecmascript-6">
  import centers from '../template/center'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {


            };
        },
        methods: {

        },
        created() {

        },
        components: {
          centers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/xuefen.vue